import React, { useEffect, useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import { BodyContainer, Header, HeaderBtn, HeaderTitle } from "../bank/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DataTable from "react-data-table-component";
import Loader from "../../components/components/Loader";
import AddPayment from "./AddPayment";
import UpdatePayment from "./UpdatePayment";

import useGetBanks from "../bank/useGetBanks";
import useGetPayments from "./useGetPayments";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import Repo from "../../Repository/Repo";
import DeleteDialog from "../../components/reusableComponents/DeleteDialog";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Toast } from "../../components/components/Toast";

function Payment() {
  //   const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [remModal, setRemModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const companyCode = localStorage.getItem("companyCode");

  useEffect(() => {
    getPayments();
  }, []);
  const columns = [
    {
      name: "DATE",
      selector: (row) => moment.unix(row?.created_at).format("DD-MM-YYYY"),
    },
    {
      name: "PAYMENT#",
      selector: (row) => row?.type,
    },
    {
      name: "RECEIVER",
      selector: (row) => localStorage.getItem("username"),
    },
    // {
    //   name: "PAYER",
    //   selector: (row) => row?.payer,
    // },
    {
      name: "PAYER",
      selector: (row) => row?.payer,
    },
    // {
    //   name: "TRANSACTION MODE",
    //   selector: (row) => row?.type,
    // },
    {
      name: "AMOUNT",
      selector: (row) => row?.amount,
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <Stack direction="row" alignItems="center" spacing="16px">
            {/* <InfoIcon
              sx={{ color: "#4eaf51" }}
              onClick={() => handleEdit(row, "details")}
            /> */}
            <BorderColorIcon
              sx={{ color: "#4eaf51" }}
              onClick={() => handleEdit(row, "edit")}
            />
            {companyCode !== "4890" && (
              <DeleteForeverIcon
                sx={{ color: "#D35353" }}
                onClick={() => handleEdit(row, "remove")}
              />
            )}
          </Stack>
        );
      },
    },

    // {
    //   name: "ACTION",
    //   cell: (row) => {
    //     return (
    //       <Stack direction="row" alignItems="center" spacing="16px">
    //         <Link to="/inventory/admin/payment-details">
    //           <Button
    //             size="small"
    //             variant="contained"
    //             sx={{ textTransform: "none" }}
    //           >
    //             View Payment
    //           </Button>
    //         </Link>
    //       </Stack>
    //     );
    //   },
    // },
  ];
  const getPayments = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.payment({
        request: {
          method: "getPaymentsByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        setPayments(data.response.data.paymentArr);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const deletePaymentRecords = async (row) => {
    try {
      setLoading(true);
      let { data } = await Repo.payment({
        request: {
          method: "deletePayment",
          data: {
            _id: selectedRow._id,
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        // setRecords(data.response.data.banks);
        Toast("success", "Payment  Deleted Successfully");

        getPayments();
        remToggle();
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const deletePaymentFromCashInHand = async (row) => {
    try {
      let paymentInCashInHandMethod =
        selectedRow.type === "Cash"
          ? "paymentsInCashInHand"
          : "paymentsInBanks";
      let bankMethod = selectedRow.type === "Cash" ? "" : "bankId";
      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: paymentInCashInHandMethod,
          data: {
            company_code: localStorage.getItem("companyCode"),
            [bankMethod]: selectedRow.bankId,
            paymentId: selectedRow._id,
            paymentDeleted: true,
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        // setRecords(data.response.data.banks);
        Toast("success", "Payment  Deleted Successfully");

        getPayments();
        remToggle();
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };
  const handleEdit = (row, type = null) => {
    setSelectedRow(row);
    if (type == "remove") {
      console.log("rem", row);
      remToggle(row);
      // handleRemove(row)
    } else if (type == "edit") {
      editToggle(row);
    }
    // else {
    //   console.log('remtwo',row)

    //   toggle(row);
    // }
  };
  const remToggle = () => {
    setRemModal((prev) => !prev);
  };
  const editToggle = () => {
    setEditModal((prev) => !prev);
  };
  const { banks } = useGetBanks();
  // const { payments, loading } = useGetPayments();
  const toggle = () => {
    setAddModal((prev) => !prev);
  };
  const onSuccess = (e) => {
    editToggle();
    getPayments();
  };
  const handleRemove = async (row) => {
    console.log("remove", row);
    await deletePaymentRecords(row);
    await deletePaymentFromCashInHand(row);
  };
  return (
    <Box>
      <Header>
        <HeaderTitle>Payment</HeaderTitle>
        <HeaderBtn variant="contained" onClick={toggle}>
          <AddCircleOutlineIcon sx={{ mr: "8px" }} /> Add new payment
        </HeaderBtn>
      </Header>
      <BodyContainer>
        <DataTable
          columns={columns}
          // data={payments}
          data={payments}
          highlightOnHover={true}
          pointerOnHover={true}
          Clicked
          pagination
          //   onRowClicked={(row) => handleRow(row)}
        />
        {loading && <Loader loading={true} />}
      </BodyContainer>

      {addModal && (
        <AddPayment onClose={toggle} banks={banks} payments={getPayments} />
      )}
      {editModal && (
        <UpdatePayment
          onClose={editToggle}
          onSuccess={onSuccess}
          // onUpdate={handleUpdate}
          banks={banks}
          row={selectedRow}
          payments={getPayments}
        />
      )}

      {remModal && (
        <DeleteDialog
          open={true}
          onClose={remToggle}
          onClickYes={handleRemove}
        />
      )}
    </Box>
  );
}

export default Payment;
